<template>
    <div class="EducationView">
        <div class="-mt-1 mb-3 text-sm font-medium sm:-mt-3">
            {{ headline }}
        </div>

        <div class="-my-5 divide-y divide-gray-400 dark:divide-default">
            <EducationViewItem
                v-for="(item, index) in items"
                :key="index"
                class="py-5"
                :item="item"
                :secondary="secondary"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { School } from '#shared/types/User'
import EducationViewItem from '@/components/profile/EducationViewItem.vue'

defineProps({
    items: {
        type: Array as PropType<School[]>,
        default: () => []
    },
    headline: {
        type: String,
        default: ''
    },
    secondary: {
        type: Boolean,
        default: false
    }
})
</script>